<template lang="pug">
.container.grid-lg.py-2
  form.columns.align-center.my-2(@submit.prevent='listar')
    .form-group.column.col-4.col-md-6.col-sm-12
      small {{ 'cadastro_protegido.doc_modelo' | tModel }}
      doc-modelo-picker(v-model='q.doc_modelo_id_eq' sm)
    .form-group.column.col-4.col-md-6.col-sm-12
      small {{ 'cadastro_protegido.cadastro' | tModel }}
      cadastro-picker(v-model="q.cadastro_id_eq" sm)
    .form-group.column.col-auto
      button.btn.btn-link.tooltip.tooltip-bottom(type='submit' data-tooltip='Filtrar', :disabled='loading')
        i.fa.fa-search.fa-lg
      router-link.btn.btn-link(:to="{ name: 'app.cadastroProtegidos.new' }" v-acl:allowed.cadastro_protegidos.create)
        i.fa-lg.fa.fa-plus
        |  Novo

  load-manager(:status='status')
    list-manager(:status='status', :count='list.length')
      .card.mb-2(v-for="item in list")
        .card-header
          .columns
            .column.col-auto
              .item-col
                .abbr {{ 'cadastro_protegido.cadastro' | tModel }}
                  span(v-if='item.cadastro')  {{ item.cadastro | enums('cadastro.tipo') }}
                .card-title.h6
                  span(v-if='item.cadastro') {{ item.cadastro.numero }}
                  span(v-else) -
            .column
              .item-col
                .abbr {{ 'cadastro_protegido.doc_modelo' | tModel }}
                .card-title.text-small
                  span(v-if='item.doc_modelo') {{ item.doc_modelo.descricao }}
                  span(v-else) -
        .card-body
          .columns
            item-col.col-auto.mb-2(label='cadastro_protegido.inicia_em' :value='item.inicia_em | date("DD/MM/YYYY")')
            item-col.col-auto.mb-2(label='cadastro_protegido.termina_em' :value='item.termina_em | date("DD/MM/YYYY")')
            item-col.col-auto.mb-2(label='cadastro_protegido.protocolo_numero' :value="`${item.protocolo_numero}/${item.protocolo_ano}`")
            item-col.col-auto.mb-2(label='cadastro_protegido.created_at' :value='item.created_at | date')
            item-col.col-auto.mb-2(label='cadastro_protegido.updated_at' :value='item.updated_at | date')
            item-col.col-12.mb-2(label='cadastro_protegido.descricao' :value='item.descricao')
        .card-footer
          .columns
            .column
              btn-logs(entityName='CadastroProtegido', :entityId='item.id' v-acl:allowed.admin.logs.index)
            .column.col-auto
              router-link.btn.btn-link.tooltip.tooltip-left(
                :data-tooltip="'views.buttons.edit.label' | translate"
                :to="{name: 'app.cadastroProtegidos.edit', params: {id: item.id}}"
              )
                btn-content(name='edit')
      .my-2.text-right(v-if='pages > 1')
        btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')

</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'

export default {
  vuex: {
    cadastroProtegidos: vuexDefaultMapping,
  },
  data() {
    return { q: { id_order_by: 'desc' } }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
